<template>
    <div class="page_stats" style="margin:20px 0 0 0;">

        <v-layout id="content" row justify-center v-if="$store.state.session.user">
            <v-flex xs12>
                <v-card>
                    <v-card-title primary-title>
                        <div>
                            <h3 class="headline mb-0">Statistik</h3>
                        </div>
                    </v-card-title>
                    <v-card-text>
                        <v-expansion-panel>
                            <v-expansion-panel-content :id="i" v-for="(item,i) in this.rows" :key="i"
                                                       @click.native="decodeRow(i)">
                                <div slot="header">
                                    [{{i}}] {{item.datum}} {{item.mode}} {{item.rechner}}
                                </div>
                                <v-card>
                                    <v-card-text class="grey lighten-3">
                                        <div v-if="item.dataSet">
                                            <h5>
                                                {{item.dataSet.formDaten.versnehm_anrede}} {{item.dataSet.formDaten.versnehm_vorname}} {{item.dataSet.formDaten.versnehm_nachname}}
                                            </h5>
                                            <pre v-html="item.dataIndentedString"></pre>
                                        </div>
                                    </v-card-text>
                                </v-card>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn flat class="orange--text" @click="loadStats()">load stats</v-btn>
                        <v-text-field
                                label="decrypt Passwort"
                                v-model="decryptPass"
                                required
                        ></v-text-field>
                        <v-btn flat class="orange--text" @click="logOut()">Abmelden</v-btn>
                    </v-card-actions>
                </v-card>
            </v-flex>
        </v-layout>
        <!--============================================================================================================-->
        <!--============================================================================================================-->

        <v-layout id="login-form" row justify-center v-else>
            <v-flex xs5>
                <v-card>
                    <v-card-title primary-title>
                        <div>
                            <h3 class="headline mb-0">Anmeldung</h3>
                        </div>
                    </v-card-title>
                    <v-card-text>
                        <v-form>
                            <v-text-field
                                    label="Name"
                                    v-model="loginName"
                                    required
                            ></v-text-field>
                            <v-text-field
                                    label="Passwort"
                                    v-model="loginPass"
                                    required
                            ></v-text-field>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn flat class="orange--text" @click="logIn()">Anmelden</v-btn>
                    </v-card-actions>
                </v-card>
            </v-flex>
        </v-layout>
        <!--============================================================================================================-->
        <!--============================================================================================================-->
        <template id="modal-spinner">
            <v-layout row justify-center>
                <v-dialog v-model="showWaitingSpinner" persistent>
                    <v-card style="overflow: hidden;">
                        <v-card-text style="position: relative">
                            <div>
                                Ihr Antrag wird übermittelt ...
                                <input @keyup.alt.88="showWaitingSpinner=false" value="" ref="focusDummy"
                                       style="position: absolute;top:1px;left: 1px;width: 100%;height: 100%;opacity: 0.001;cursor: pointer">
                            </div>
                            <v-progress-circular indeterminate v-bind:size="50" class="primary--text"/>
                            <div>
                                Bitte warten!
                            </div>
                        </v-card-text>
                    </v-card>
                </v-dialog>
            </v-layout>
        </template>
        <!--============================================================================================================-->
        <!--============================================================================================================-->
        <template id="modal-feedback">
            <v-layout row justify-center>
                <v-dialog v-model="showErrorInfo" persistent>
                    <v-card style="overflow: hidden;">
                        <v-card-text style="position: relative; text-align: center">
                            <div>
                                <br>
                                <br>
                                Anfrage nicht möglich
                                <br>
                                <br>
                                {{this.error_id}}
                                <br>
                                <br>
                                {{this.error_text}}
                            </div>
                            <v-btn style="" @click.native="showErrorInfo=false">
                                weiter
                            </v-btn>
                        </v-card-text>
                    </v-card>
                </v-dialog>
            </v-layout>
        </template>
        <!--============================================================================================================-->
        <!--============================================================================================================-->

    </div>
</template>
<!-- _____________________________________________________________________________________________________________________________________________________________ -->
<!-- ############################################################################################################################################################# -->
<script>
  import CryptoJS from 'crypto-js'
  // import _ from 'lodash'

  export default {
    name: 'stats',
    data: function () {

      return {
        loginName: '',
        loginPass: '',
        decryptPass: '',
        showWaitingSpinner: false,
        showErrorInfo: false,
        error_id: '',
        error_text: '',
        rows: [],


      }
    }, //============================================================================================================================
    methods: {
      //__________________________________________________________________________________________________________________________
      decrypt_from_PHP: function (passphrase, cryptBox) {

        //var obj_json = JSON.parse(encrypted_json_string);

        var encrypted = cryptBox.ciphertext;
        var salt = CryptoJS.enc.Hex.parse(cryptBox.salt);
        var iv = CryptoJS.enc.Hex.parse(cryptBox.iv);

        var key = CryptoJS.PBKDF2(passphrase, salt, {hasher: CryptoJS.algo.SHA512, keySize: 64 / 8, iterations: 999});

        var decrypted = CryptoJS.AES.decrypt(encrypted, key, {iv: iv});

        //return decrypted.toString();
        return decrypted.toString(CryptoJS.enc.Utf8);
      }, //__________________________________________________________________________________________________________________________
      encrypt_for_PHP: function (passphrase, plain_text) {

        var salt = CryptoJS.lib.WordArray.random(256);
        var iv = CryptoJS.lib.WordArray.random(16);
        //for more random entropy can use : https://github.com/wwwtyro/cryptico/blob/master/random.js instead CryptoJS random() or another js PRNG

        var key = CryptoJS.PBKDF2(passphrase, salt, {hasher: CryptoJS.algo.SHA512, keySize: 64 / 8, iterations: 999});

        var encrypted = CryptoJS.AES.encrypt(plain_text, key, {iv: iv});

        var crypt_box = {
          ciphertext: CryptoJS.enc.Base64.stringify(encrypted.ciphertext),
          salt: CryptoJS.enc.Hex.stringify(salt),
          iv: CryptoJS.enc.Hex.stringify(iv)
        }

        return crypt_box;

      }, //__________________________________________________________________________________________________________________________
      logIn: function () {

        this.showWaitingSpinner = true;
        this.$store.dispatch(
          'sendApiRequest',
          {
            sender: 'RechnerTemplate->created',
            command: 'get_sid',
            //-------------------------------------------------------------------------------------------
            onError: (response1) => {
              this.showWaitingSpinner = false;
              this.error_id = 'Login fehlgeschlagen'
              this.error_text = 'Session konnte nicht initiiert werden'
              this.showErrorInfo = true;
            }, //-------------------------------------------------------------------------------------------
            onSuccess: (response1) => {
              var $dataText = response1.data.sid;


              var passHash = CryptoJS.MD5(this.loginPass).toString();
              console.log('passHash: ', passHash);
              var crypt_box = this.encrypt_for_PHP(passHash, $dataText)
              sessionStorage.setItem("session_id", response1.data.sid)
              this.$store.dispatch(
                'sendApiRequest',
                {
                  sender: 'RechnerTemplate->created',
                  command: 'logIn',
                  args: {
                    username: this.loginName,
                    crypt_box: crypt_box,
                  }, //................................................................................
                  onError: (response2) => {
                    this.showWaitingSpinner = false;
                    this.$store.commit('set_rechnerStatus', {data: 'Antrag: submit failed'});
                    console.log("1=>=>=>", response2.data)
                    this.error_id = response2.data.error_id
                    this.error_text = response2.data.error_text;
                    this.showErrorInfo = true;
                  }, //................................................................................
                  onSuccess: (response2) => {
                    this.showWaitingSpinner = false;
                    console.log("3=>=>=>", response2.data)
                    if (response2.data.user && response2.data.user.username === this.loginName) {
                      this.$store.commit('session_setUser', {data: response2.data.user});
                      sessionStorage.setItem("session_id", response2.data.sid)
                      console.log("%cLOGIN okay", "background-color:lime;color:black", response2);

                    } else {
                      this.error_id = 'Login fehlgeschlagen'
                      this.error_text = 'der User konnte nicht angemeldet werden';
                      console.log("%cLOGIN failed", "background-color:red;color:yellow", response2);
                    }
                    this.$forceUpdate();
                  }, //................................................................................

                }
              );

            }, //-----------------------------------------------------------------------------------------------

          }
        );
      }, //__________________________________________________________________________________________________________________________
      logOut: function () {

        this.$store.dispatch(
          'sendApiRequest',
          {
            sender: 'RechnerTemplate->created',
            command: 'logOut',
            //................................................................................
            onError: (response) => {
              console.log("4=>=>=>", response.data)
              this.showWaitingSpinner = false;
              this.error_id = response.data.error_id
              this.error_text = response.data.error_text;
              this.showErrorInfo = true;
            }, //................................................................................
            onSuccess: (response) => {
              console.log("6=>=>=>", response.data)
              this.showWaitingSpinner = false;
              if (response.data.status === 'success') {
                console.log("%cLOGOUT okay", "background-color:lime;color:black", response);
                sessionStorage.setItem("session_id", null)
                this.$store.commit('session_setUser', {data: null});
              } else {
                console.log("%cLOGOUT failed", "background-color:red;color:yellow", response);
              }
              this.$forceUpdate();
            }, //................................................................................

          });
      },  //__________________________________________________________________________________________________________________________
      loadStats: function () {

        this.$store.dispatch(
          'sendApiRequest',
          {
            sender: 'RechnerTemplate->created',
            command: 'load_stats',
            //................................................................................
            onError: (response) => {
              console.log("7=>=>=>", response.data)
              this.showWaitingSpinner = false;
              this.error_id = response.data.error_id
              this.error_text = response.data.error_text;
              this.showErrorInfo = true;
            }, //................................................................................
            onSuccess: (response) => {
              /*
              console.log("8=>=>=>", response.data)

              this.showWaitingSpinner = false;
              this.rows = []
              for (var key in response.data.rows) {
                var row = response.data.rows[key]
                var password = this.loginPass
                //var passHash = CryptoJS.MD5(this.loginPass).toString();

              //  var dataJson = this.decrypt_from_PHP(password, row);
                var dataSet = JSON.parse(dataJson)
                //console.log("dec" + key, dataSet)
                this.rows.push(dataSet)
              }
               */
              this.rows = response.data.rows

              this.$forceUpdate();
            }, //................................................................................

          });
      },  //__________________________________________________________________________________________________________________________
      decodeRow: function (index) {

        var row = this.rows[index]
        console.log(index, row)
        if (!this.rows.dataSet) {
          var password = this.decryptPass
          var dataJson = this.decrypt_from_PHP(password, row);
          var dataSet = JSON.parse(dataJson)
          var data = JSON.stringify(dataSet, null, '\t')
          data = data.replace(/(\t")(.*)(":)/g, "$1<span class='label'>$2</span>$3")  // label formatieren
          data = data.replace(/(: ")(.*)"([,|\n])/g, "$1<span class='value'>$2</span>$3")  // value formatieren
          data = data.replace(/"/g, "")  // Anführungszeichen entfernen
          row.dataIndentedString = data
          row.dataSet = dataSet
          this.rows[index] = row
          console.log(index, this.rows[index].dataSet)
          //this.rows = _.assign({}, this.rows)
          this.$forceUpdate();
        }
      },  //__________________________________________________________________________________________________________________________

    }, //======================================================================================================================================
  }
</script>
<!-- ############################################################################################################################################################# -->
<!-- ¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯ -->
<style>
    .expansion-panel__container--active .expansion-panel__header {
        font-weight: bold;
        background: #d3dbff;
    }

    .expansion-panel__container--active .label {
        background: #eed9ff;
        font-weight: bold;
        color: #890004;
    }

    .expansion-panel__container--active .value {
        background: #e7e2ff;
        font-style: italic;
        font-style: italic;
    }
</style>
